import React, { useMemo } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

// global scss for globally styles and fonts
import "./_fonts.scss";
import "./_global.scss";

import PublicRoute from "./Components/Routes/PublicRoute.js";
import { WEB_ROUTES } from "./constants.js";
import { baseRoute } from "./Helper";

import { uniqueId } from "lodash";
import ProtectedLayout from "./Components/Layouts/ProtectedLayout.js";
import ProtectedRoute from "./Components/Routes/ProtectedRoute.js";
import Account from "./Pages/Account";
import BookingManagementScreen from "./Pages/bookingManagement/bookingManagmentScreen.js";
import Dashboard from "./Pages/Dashboard";
import DisputeManagementScreen from "./Pages/disputeManagement/disputeManagmentScreen.js";
import DisputeReasonScreen from "./Pages/disputeReason/disputeReasonScreen.js";
import ListingManagementScreen from "./Pages/listingManagemnt/listingManagmentScreen.js";
import SendNotificationScreen from "./Pages/SendNotification/SendNotificationScreen.js";
import Setting from "./Pages/Setting";
import UserManagement from "./Pages/UserManagement";

function App() {
  // todo: menu
  const ROUTES = useMemo(() => {
    return [
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.ACCOUNT)}
        element={
          <PublicRoute>
            <Account />
          </PublicRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.DASHBOARD)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={0}>
              <Dashboard />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      // <Route key={uniqueId} exact path={baseRoute(WEB_ROUTES.TOURNAMENT_MANAGEMENT)} element={
      //   <ProtectedRoute>
      //     <ProtectedLayout isSearchBar={false} selectedRoute={1}>
      //       <TournamentManagement />
      //     </ProtectedLayout>
      //   </ProtectedRoute>
      // } />,
      // <Route key={uniqueId} exact path={baseRoute(WEB_ROUTES.PLAYER_MANAGEMENT)} element={
      //   <ProtectedRoute>
      //     <ProtectedLayout isSearchBar={true} selectedRoute={2}>
      //       <PlayerManagement />
      //     </ProtectedLayout>
      //   </ProtectedRoute>
      // } />,
      // <Route key={uniqueId} exact path={baseRoute(WEB_ROUTES.COACH_MANAGEMENT)} element={
      //   <ProtectedRoute>
      //     <ProtectedLayout isSearchBar={true} selectedRoute={3}>
      //       <CoachManagement />
      //     </ProtectedLayout>
      //   </ProtectedRoute>
      // } />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.USER_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={1}>
              <UserManagement />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.LISTING_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={2}>
              <ListingManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.BOOKING_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={3}>
              <BookingManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.DISPUTE_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={4}>
              <DisputeManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.DISPUTE_REASON)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={5}>
              <DisputeReasonScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.SEND_NOTIFICATION)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={6}>
              <SendNotificationScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.SETTING)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={7}>
              <Setting />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      // <Route key={uniqueId} exact path={baseRoute(WEB_ROUTES.PROFILE)} element={
      //   <ProtectedRoute>
      //     <ProtectedLayout isSearchBar={false} selectedRoute={9}>
      //       <Profile />
      //     </ProtectedLayout>
      //   </ProtectedRoute>
      // } />,
    ];
  }, []);

  return (
    <Router>
      <Routes>
        {ROUTES.map((item) => item)}
        <Route
          path={baseRoute("*")}
          element={<Navigate to={baseRoute(WEB_ROUTES.ACCOUNT)} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
